<template>
  <div class="language-main">
    <span class="language-text">简体中文</span>
    <i class="drop-down"></i>
  </div>
</template>

<script>
export default {
  name: "OEMLanguage",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.language-main {
  margin-top: 15px;
  cursor: pointer;
}
.language-text {
  width: 65px;
  height: 22px;
  opacity: 0.99;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: center;
  font-weight: 400;
}
.drop-down {
  display: inline-block;
  width: 10px;
  height: 8px;
  margin-left: 10px;
  margin-right: 10px;
  background-image: url("../../assets/images/drop_down.png");
  background-size: 100%;
}
</style>
